import React, { useRef, useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Box, Button, Divider, FormControlLabel , Typography, useTheme, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from "@mui/material";
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { ComposedChart, Area, Bar, Scatter, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
  GridEditInputCell,
  GridColDef,
  gridClasses
} from '@mui/x-data-grid';
import { styled } from "@mui/material/styles";
import WidgetWrapper from '../../components/WidgetWrapper';
// import BarChartSimple from '../../components/BarChart';
import RadarChartSimple from '../../components/RadarChart';
import PieChartSimple from '../../components/PieChart';
import DataGridCustomToolbar from '../../components/DataGridCustomToolbar';
import { Description } from '@mui/icons-material';
// import HeatMapChart from '../../../../components/HeatMapChart.jsx';
// import Example from '../../../../components/Treemap.jsx';
import StackedBarChart from '../../components/StackedBarChart.jsx';

// const data00 = [
//   { name: 'Group A', value: 400, fill: '#8884d8' },
//   { name: 'Group B', value: 300, fill: '#459875' },
//   { name: 'Group C', value: 300, fill: '#987043' },
//   { name: 'Group D', value: 200, fill: '#342190' },
// ];

// const data01 = [
//   { name: 'Group A', value: 400 },
//   { name: 'Group B', value: 300 },
//   { name: 'Group C', value: 300 },
//   { name: 'Group D', value: 200 },
// ];
// const data02 = [
//   { name: 'A1', value: 100 },
//   { name: 'A2', value: 300 },
//   { name: 'B1', value: 100 },
//   { name: 'B2', value: 80 },
//   { name: 'B3', value: 40 },
//   { name: 'B4', value: 30 },
//   { name: 'B5', value: 50 },
//   { name: 'C1', value: 100 },
//   { name: 'C2', value: 200 },
//   { name: 'D1', value: 150 },
//   { name: 'D2', value: 50 },
// ];

const data = [
  {
    name: 'Page A',
    uv: 4000,
    pv: 2400,
    amt: 2400,
    cnt: 4
  },
  {
    name: 'Page B',
    uv: 3000,
    pv: 1398,
    amt: 2210,
    cnt: 4
  },
  {
    name: 'Page C',
    uv: 2000,
    pv: 9800,
    amt: 2290,
    cnt: 4
  },
  {
    name: 'Page D',
    uv: 2780,
    pv: 3908,
    amt: 2000,
    cnt: 4
  },
  {
    name: 'Page E',
    uv: 1890,
    pv: 4800,
    amt: 2181,
    cnt: 4
  },
  {
    name: 'Page F',
    uv: 2390,
    pv: 3800,
    amt: 2500,
    cnt: 4
  },
  {
    name: 'Page G',
    uv: 3490,
    pv: 4300,
    amt: 2100,
    cnt: 4
  },
];


const ZTAResults = ({assessmentName,
  id1, 
id2, 
id3, 
id4, 
id5, 
id6, 
id7, 
dv1, 
dv2, 
dv3, 
dv4, 
dv5, 
dv6, 
dv7, 
aw1, 
aw2, 
aw3, 
aw4, 
aw5, 
aw6, 
aw7, 
aw8, 
nt1, 
nt2, 
nt3, 
nt4, 
nt5, 
nt6, 
nt7, 
da1, 
da2, 
da3, 
da4, 
da5, 
da6, 
da7, 
da8, 
cc1,
cc2,
cc3,
id1Comments,
id2Comments,
id3Comments,
id4Comments,
id5Comments,
id6Comments,
id7Comments,
dv1Comments,
dv2Comments,
dv3Comments,
dv4Comments,
dv5Comments,
dv6Comments,
dv7Comments,
aw1Comments,
aw2Comments,
aw3Comments,
aw4Comments,
aw5Comments,
aw6Comments,
aw7Comments,
aw8Comments,
nt1Comments,
nt2Comments,
nt3Comments,
nt4Comments,
nt5Comments,
nt6Comments,
nt7Comments,
da1Comments,
da2Comments,
da3Comments,
da4Comments,
da5Comments,
da6Comments,
da7Comments,
da8Comments,
cc1Comments,
cc2Comments,
cc3Comments,

}) => {

      const axiosPrivate = useAxiosPrivate();
      const { assessmentID } = useParams();
      const [assessmentData, setAssessmentData] = useState();
      // const [assessmentName, setAssessmentName] = useState();
      
      const navigate = useNavigate();
      const location = useLocation();
      const userRef = useRef();
      const errRef = useRef();
      const [errMsg, setErrMsg] = useState('');
      const theme = useTheme();        
      const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");    // From mern_app project
      const isNonMobile = useMediaQuery("(min-width:600px)");             // From mern_app project
      const [rowsDataGrid, setRowsDataGrid] = useState([]);
      const [questions, setQuestions] = useState([]);

    //   const questionsIdentityList = [];
    //   const questionsDevicesList = [];
    //   const questionsApplicationsWorkloadsList = [];
    //   const questionsNetworksList = [];
    //   const questionsDataList = [];
    {/* 
    // ZTA Identity Question variables.
      const [id1, setID1] = useState('');
      const [id2, setID2] = useState('');
      const [id3, setID3] = useState('');
      const [id4, setID4] = useState('');
      const [id5, setID5] = useState('');
      const [id6, setID6] = useState('');
      const [id7, setID7] = useState('');
      const [id1Comments, setID1Comments] = useState('');
      const [id2Comments, setID2Comments] = useState('');
      const [id3Comments, setID3Comments] = useState('');
      const [id4Comments, setID4Comments] = useState('');
      const [id5Comments, setID5Comments] = useState('');
      const [id6Comments, setID6Comments] = useState('');
      const [id7Comments, setID7Comments] = useState('');
    
      // ZTA Devices Question Variables.
      const [dv1, setDV1] = useState('');
      const [dv2, setDV2] = useState('');
      const [dv3, setDV3] = useState('');
      const [dv4, setDV4] = useState('');
      const [dv5, setDV5] = useState('');
      const [dv6, setDV6] = useState('');
      const [dv7, setDV7] = useState('');
      const [dv1Comments, setDV1Comments] = useState('');
      const [dv2Comments, setDV2Comments] = useState('');
      const [dv3Comments, setDV3Comments] = useState('');
      const [dv4Comments, setDV4Comments] = useState('');
      const [dv5Comments, setDV5Comments] = useState('');
      const [dv6Comments, setDV6Comments] = useState('');
      const [dv7Comments, setDV7Comments] = useState('');
    
      // ZTA Networks Question Variables.
      const [nt1, setNT1] = useState('');
      const [nt2, setNT2] = useState('');
      const [nt3, setNT3] = useState('');
      const [nt4, setNT4] = useState('');
      const [nt5, setNT5] = useState('');
      const [nt6, setNT6] = useState('');
      const [nt7, setNT7] = useState('');
      const [nt1Comments, setNT1Comments] = useState('');
      const [nt2Comments, setNT2Comments] = useState('');
      const [nt3Comments, setNT3Comments] = useState('');
      const [nt4Comments, setNT4Comments] = useState('');
      const [nt5Comments, setNT5Comments] = useState('');
      const [nt6Comments, setNT6Comments] = useState('');
      const [nt7Comments, setNT7Comments] = useState('');
 
    
      // ZTA Applications & Workloads Question Variables.
      const [aw1, setAW1] = useState('');
      const [aw2, setAW2] = useState('');
      const [aw3, setAW3] = useState('');
      const [aw4, setAW4] = useState('');
      const [aw5, setAW5] = useState('');
      const [aw6, setAW6] = useState('');
      const [aw7, setAW7] = useState('');
      const [aw8, setAW8] = useState('');
      const [aw1Comments, setAW1Comments] = useState('');
      const [aw2Comments, setAW2Comments] = useState('');
      const [aw3Comments, setAW3Comments] = useState('');
      const [aw4Comments, setAW4Comments] = useState('');
      const [aw5Comments, setAW5Comments] = useState('');
      const [aw6Comments, setAW6Comments] = useState('');
      const [aw7Comments, setAW7Comments] = useState('');
      const [aw8Comments, setAW8Comments] = useState('');
    
      // ZTA Applications & Workloads Question Variables.
      const [da1Comments, setDA1Comments] = useState('');
      const [da2Comments, setDA2Comments] = useState('');
      const [da3Comments, setDA3Comments] = useState('');
      const [da4Comments, setDA4Comments] = useState('');
      const [da5Comments, setDA5Comments] = useState('');
      const [da6Comments, setDA6Comments] = useState('');
      const [da7Comments, setDA7Comments] = useState('');
      const [da8Comments, setDA8Comments] = useState('');
      const [da1, setDA1] = useState('');
      const [da2, setDA2] = useState('');
      const [da3, setDA3] = useState('');
      const [da4, setDA4] = useState('');
      const [da5, setDA5] = useState('');
      const [da6, setDA6] = useState('');
      const [da7, setDA7] = useState('');
      const [da8, setDA8] = useState('');

       //ZTA Cross-Cutting Capabilities
        const [cc1, setCC1] = useState('');
        const [cc2, setCC2] = useState('');
        const [cc3, setCC3] = useState('');
        const [cc1Comments, setCC1Comments] = useState('');
        const [cc2Comments, setCC2Comments] = useState('');
        const [cc3Comments, setCC3Comments] = useState('');

      */}

      const [idScore, setIdScore] = useState(0);
      const [dvScore, setDvScore] = useState(0);
      const [ntScore, setNtScore] = useState(0);
      const [awScore, setAwScore] = useState(0);
      const [daScore, setDaScore] = useState(0);
      const [ccScore, setCcScore] = useState(0);
      const [noneScore, setNoneScore] = useState(0);


      const [idTraditional, setIdTraditional] = useState(0);
      const [idInitial, setIdInitial] = useState(0);
      const [idAdvanced, setIdAdvanced] = useState(0);
      const [idOptimal, setIdOptimal] = useState(0);
      const [idNone, setIdNone] = useState(0);


      const [dvTraditional, setDvTraditional] = useState(0);
      const [dvInitial, setDvInitial] = useState(0);
      const [dvAdvanced, setDvAdvanced] = useState(0);
      const [dvOptimal, setDvOptimal] = useState(0);
      const [dvNone, setDvNone] = useState(0);


      const [ntTraditional, setNtTraditional] = useState(0);
      const [ntInitial, setNtInitial] = useState(0);
      const [ntAdvanced, setNtAdvanced] = useState(0);
      const [ntOptimal, setNtOptimal] = useState(0);
      const [ntNone, setNtNone] = useState(0);


      const [awTraditional, setAwTraditional] = useState(0);
      const [awInitial, setAwInitial] = useState(0);
      const [awAdvanced, setAwAdvanced] = useState(0);
      const [awOptimal, setAwOptimal] = useState(0);
      const [awNone, setAwNone] = useState(0);


      const [daTraditional, setDaTraditional] = useState(0);
      const [daInitial, setDaInitial] = useState(0);
      const [daAdvanced, setDaAdvanced] = useState(0);
      const [daOptimal, setDaOptimal] = useState(0);
      const [daNone, setDaNone] = useState(0);


      const [ccTraditional, setCcTraditional] = useState(0);
      const [ccInitial, setCcInitial] = useState(0);
      const [ccAdvanced, setCcAdvanced] = useState(0);
      const [ccOptimal, setCcOptimal] = useState(0);
      const [ccNone, setCcNone] = useState(0);
     
    

      const radarChartData = ([
              {
                subject: 'Identity',
                A: 7,
                fullMark: 76,
                totalBarMax: 1
              },
              {
                subject: 'Devices',
                A: 4, 
                fullMark: 120,
                totalBarMax: 1
              },
              {
                subject: 'Networks',
                A: 10,
                fullMark: 120,
                totalBarMax: 1
              },
              {
                subject: 'Applications & Workloads',
                A: 5,
                fullMark: 32,
                totalBarMax: 1
              },
              {
                subject: 'Data',
                A: 3,
                B: 6,
                fullMark: 108,
                totalBarMax: 1
              },
          ])

// Get assessmnet data Function.  This should pull data for the assessment for the current assessment. 
const getAssessmentData = async () => {
  try {
    const response = await axiosPrivate.get(`/zta/${assessmentID}`, {
      withCredentials: true
    });
    const data = await response.data;
    // console.log(data);
    setAssessmentData(JSON.parse(data.ztaAssessmentIdentityData));
    // setAssessmentName(data.assessmentName);

    // setID1(JSON.parse(data.ztaAssessmentIdentityData).id1);
    // setID2(JSON.parse(data.ztaAssessmentIdentityData).id2);
    // setID3(JSON.parse(data.ztaAssessmentIdentityData).id3);
    // setID4(JSON.parse(data.ztaAssessmentIdentityData).id4);
    // setID5(JSON.parse(data.ztaAssessmentIdentityData).id5);
    // setID6(JSON.parse(data.ztaAssessmentIdentityData).id6);
    // setID7(JSON.parse(data.ztaAssessmentIdentityData).id7);
    // setID1Comments(JSON.parse(data.ztaAssessmentIdentityData).id1Comments)
    // setID2Comments(JSON.parse(data.ztaAssessmentIdentityData).id2Comments);
    // setID3Comments(JSON.parse(data.ztaAssessmentIdentityData).id3Comments);
    // setID4Comments(JSON.parse(data.ztaAssessmentIdentityData).id4Comments);
    // setID5Comments(JSON.parse(data.ztaAssessmentIdentityData).id5Comments);
    // setID6Comments(JSON.parse(data.ztaAssessmentIdentityData).id6Comments);
    // setID7Comments(JSON.parse(data.ztaAssessmentIdentityData).id7Comments);

    // setDV1(JSON.parse(data.ztaAssessmentIdentityData).dv1);
    // setDV2(JSON.parse(data.ztaAssessmentIdentityData).dv2);
    // setDV3(JSON.parse(data.ztaAssessmentIdentityData).dv3);
    // setDV4(JSON.parse(data.ztaAssessmentIdentityData).dv4);
    // setDV5(JSON.parse(data.ztaAssessmentIdentityData).dv5);
    // setDV6(JSON.parse(data.ztaAssessmentIdentityData).dv6);
    // setDV7(JSON.parse(data.ztaAssessmentIdentityData).dv7);
    // setDV1Comments(JSON.parse(data.ztaAssessmentIdentityData).dv1Comments)
    // setDV2Comments(JSON.parse(data.ztaAssessmentIdentityData).dv2Comments);
    // setDV3Comments(JSON.parse(data.ztaAssessmentIdentityData).dv3Comments);
    // setDV4Comments(JSON.parse(data.ztaAssessmentIdentityData).dv4Comments);
    // setDV5Comments(JSON.parse(data.ztaAssessmentIdentityData).dv5Comments);
    // setDV6Comments(JSON.parse(data.ztaAssessmentIdentityData).dv6Comments);
    // setDV7Comments(JSON.parse(data.ztaAssessmentIdentityData).dv7Comments);

    // setAW1(JSON.parse(data.ztaAssessmentIdentityData).aw1);
    // setAW2(JSON.parse(data.ztaAssessmentIdentityData).aw2);
    // setAW3(JSON.parse(data.ztaAssessmentIdentityData).aw3);
    // setAW4(JSON.parse(data.ztaAssessmentIdentityData).aw4);
    // setAW5(JSON.parse(data.ztaAssessmentIdentityData).aw5);
    // setAW6(JSON.parse(data.ztaAssessmentIdentityData).aw6);
    // setAW7(JSON.parse(data.ztaAssessmentIdentityData).aw7);
    // setAW8(JSON.parse(data.ztaAssessmentIdentityData).aw8);
    // setAW1Comments(JSON.parse(data.ztaAssessmentIdentityData).aw1Comments)
    // setAW2Comments(JSON.parse(data.ztaAssessmentIdentityData).aw2Comments);
    // setAW3Comments(JSON.parse(data.ztaAssessmentIdentityData).aw3Comments);
    // setAW4Comments(JSON.parse(data.ztaAssessmentIdentityData).aw4Comments);
    // setAW5Comments(JSON.parse(data.ztaAssessmentIdentityData).aw5Comments);
    // setAW6Comments(JSON.parse(data.ztaAssessmentIdentityData).aw6Comments);
    // setAW7Comments(JSON.parse(data.ztaAssessmentIdentityData).aw7Comments);
    // setAW8Comments(JSON.parse(data.ztaAssessmentIdentityData).aw8Comments);

    // setNT1(JSON.parse(data.ztaAssessmentIdentityData).nt1);
    // setNT2(JSON.parse(data.ztaAssessmentIdentityData).nt2);
    // setNT3(JSON.parse(data.ztaAssessmentIdentityData).nt3);
    // setNT4(JSON.parse(data.ztaAssessmentIdentityData).nt4);
    // setNT5(JSON.parse(data.ztaAssessmentIdentityData).nt5);
    // setNT6(JSON.parse(data.ztaAssessmentIdentityData).nt6);
    // setNT7(JSON.parse(data.ztaAssessmentIdentityData).nt7);
    // setNT1Comments(JSON.parse(data.ztaAssessmentIdentityData).nt1Comments)
    // setNT2Comments(JSON.parse(data.ztaAssessmentIdentityData).nt2Comments);
    // setNT3Comments(JSON.parse(data.ztaAssessmentIdentityData).nt3Comments);
    // setNT4Comments(JSON.parse(data.ztaAssessmentIdentityData).nt4Comments);
    // setNT5Comments(JSON.parse(data.ztaAssessmentIdentityData).nt5Comments);
    // setNT6Comments(JSON.parse(data.ztaAssessmentIdentityData).nt6Comments);
    // setNT7Comments(JSON.parse(data.ztaAssessmentIdentityData).nt7Comments);

    // setDA1(JSON.parse(data.ztaAssessmentIdentityData).da1);
    // setDA2(JSON.parse(data.ztaAssessmentIdentityData).da2);
    // setDA3(JSON.parse(data.ztaAssessmentIdentityData).da3);
    // setDA4(JSON.parse(data.ztaAssessmentIdentityData).da4);
    // setDA5(JSON.parse(data.ztaAssessmentIdentityData).da5);
    // setDA6(JSON.parse(data.ztaAssessmentIdentityData).da6);
    // setDA7(JSON.parse(data.ztaAssessmentIdentityData).da7);
    // setDA8(JSON.parse(data.ztaAssessmentIdentityData).da8);
    // setDA1Comments(JSON.parse(data.ztaAssessmentIdentityData).da1Comments)
    // setDA2Comments(JSON.parse(data.ztaAssessmentIdentityData).da2Comments);
    // setDA3Comments(JSON.parse(data.ztaAssessmentIdentityData).da3Comments);
    // setDA4Comments(JSON.parse(data.ztaAssessmentIdentityData).da4Comments);
    // setDA5Comments(JSON.parse(data.ztaAssessmentIdentityData).da5Comments);
    // setDA6Comments(JSON.parse(data.ztaAssessmentIdentityData).da6Comments);
    // setDA7Comments(JSON.parse(data.ztaAssessmentIdentityData).da7Comments);
    // setDA8Comments(JSON.parse(data.ztaAssessmentIdentityData).da8Comments);
    
    // setCC1(JSON.parse(data.ztaAssessmentIdentityData).cc1);
    // setCC2(JSON.parse(data.ztaAssessmentIdentityData).cc2);
    // setCC3(JSON.parse(data.ztaAssessmentIdentityData).cc3);
    // setCC1Comments(JSON.parse(data.ztaAssessmentIdentityData).cc1Comments)
    // setCC2Comments(JSON.parse(data.ztaAssessmentIdentityData).cc2Comments);
    // setCC3Comments(JSON.parse(data.ztaAssessmentIdentityData).cc3Comments);
  } catch (err) {
    // alert("Login Expired.");
    console.error(err);
    // navigate('/login', { state: { from: location }, replace: true });
  }
}

const idVariablesList = [ 
    id1,	id2,  id3,	id4,	id5,	id6,	id7
    ];

const dvVariablesList = [     
    dv1,	dv2,	dv3,	dv4,	dv5,	dv6,	dv7
];
const ntVariablesList = [ 
    nt1,	nt2,	nt3,	nt4,	nt5,	nt6,	nt7	
];
const awVariablesList = [ 
    aw1,	aw2,	aw3,	aw4,	aw5,	aw6,	aw7,	aw8	
];
const daVariablesList = [     
    da1,	da2,	da3,	da4,	da5,	da6,	da7,	da8
  ];
const ccVariablesList = [
    cc1, cc2, cc3
]

const variablesList = [ 
    id1,	id2,  id3,	id4,	id5,	id6,	id7,
    dv1,	dv2,	dv3,	dv4,	dv5,	dv6,	dv7,	
    nt1,	nt2,	nt3,	nt4,	nt5,	nt6,	nt7,	
    aw1,	aw2,	aw3,	aw4,	aw5,	aw6,	aw7,	aw8,	
    da1,	da2,	da3,	da4,	da5,	da6,	da7,	da8,
    cc1,  cc2,  cc3
  ];

  const variablesCommentsList = [
    id1Comments,	id2Comments,  id3Comments,	id4Comments,	id5Comments,	id6Comments,	id7Comments,	
    dv1Comments,	dv2Comments,	dv3Comments,	dv4Comments,	dv5Comments,	dv6Comments,	dv7Comments,	
    nt1Comments,	nt2Comments,	nt3Comments,	nt4Comments,	nt5Comments,	nt6Comments,	nt7Comments,	
    aw1Comments,	aw2Comments,	aw3Comments,	aw4Comments,	aw5Comments,	aw6Comments,	aw7Comments,	aw8Comments,	
    da1Comments,	da2Comments,	da3Comments,	da4Comments,	da5Comments,	da6Comments,	da7Comments,	da8Comments,
    cc1Comments,  cc2Comments,  cc3Comments,
  ];


const getVariableScores = (ztaVariable) => {
    if (ztaVariable==='Traditional') return 1;
    if (ztaVariable==='Initial') return 2;
    if (ztaVariable==='Advanced') return 3;
    if (ztaVariable==='Optimal') return 4;
    if (ztaVariable==='None') {
        return 0;
    } else return 0;
};


// CALCULATE ASSESSMENT SCORES FOR RESULTS PAGE.
const getZTAAssessmentScores = () => {
    let tempIdTraditional = 0;
    let tempIdInitial = 0;
    let tempIdAdvanced = 0;
    let tempIdOptimal = 0;
    let tempIdNone = 0;

    for (let i=0; i<idVariablesList.length+1; i++) {
        if (idVariablesList[i]==='Traditional') {
            tempIdTraditional = tempIdTraditional +1;
        }
        if (idVariablesList[i]==='Initial') {
            tempIdInitial = tempIdInitial +1;
        }
        if (idVariablesList[i]==='Advanced') {
            tempIdAdvanced = tempIdAdvanced +1;
        }
        if (idVariablesList[i]==='Optimal') {
            tempIdOptimal = tempIdOptimal +1;
        } 
        if (idVariablesList[i]==='None') {
            tempIdNone = tempIdNone +1;
        } 
    } 

    let tempDvTraditional = 0;
    let tempDvInitial = 0;
    let tempDvAdvanced = 0;
    let tempDvOptimal = 0;
    let tempDvNone = 0;
    for (let i=0; i<dvVariablesList.length+1; i++) {
        if (dvVariablesList[i]==='Traditional') {
            tempDvTraditional = tempDvTraditional +1;
        }
        if (dvVariablesList[i]==='Initial') {
            tempDvInitial = tempDvInitial +1;
        }
        if (dvVariablesList[i]==='Advanced') {
            tempDvAdvanced = tempDvAdvanced +1;
        }
        if (dvVariablesList[i]==='Optimal') {
            tempDvOptimal = tempDvOptimal +1;
        } 
        if (dvVariablesList[i]==='None') {
            tempDvNone = tempDvNone +1;
        } 
    } 

    let tempNtTraditional = 0;
    let tempNtInitial = 0;
    let tempNtAdvanced = 0;
    let tempNtOptimal = 0;
    let tempNtNone = 0;
    for (let i=0; i<ntVariablesList.length+1; i++) {
        if (ntVariablesList[i]==='Traditional') {
            tempNtTraditional = tempNtTraditional +1;
        }
        if (ntVariablesList[i]==='Initial') {
            tempNtInitial = tempNtInitial +1;
        }
        if (ntVariablesList[i]==='Advanced') {
            tempNtAdvanced = tempNtAdvanced +1;
        }
        if (ntVariablesList[i]==='Optimal') {
            tempNtOptimal = tempNtOptimal +1;
        } 
        if (ntVariablesList[i]==='None') {
            tempNtNone = tempNtNone +1;
        } 
    } 

    let tempAwTraditional = 0;
    let tempAwInitial = 0;
    let tempAwAdvanced = 0;
    let tempAwOptimal = 0;
    let tempAwNone = 0;
    for (let i=0; i<awVariablesList.length+1; i++) {
        if (awVariablesList[i]==='Traditional') {
            tempAwTraditional = tempAwTraditional +1;
        }
        if (awVariablesList[i]==='Initial') {
            tempAwInitial = tempAwInitial +1;
        }
        if (awVariablesList[i]==='Advanced') {
            tempAwAdvanced = tempAwAdvanced +1;
        }
        if (awVariablesList[i]==='Optimal') {
            tempAwOptimal = tempAwOptimal +1;
        } 
        if (awVariablesList[i]==='None') {
            tempAwNone = tempAwNone +1;
        } 
    } 

    let tempDaTraditional = 0;
    let tempDaInitial = 0;
    let tempDaAdvanced = 0;
    let tempDaOptimal = 0;
    let tempDaNone = 0;
    for (let i=0; i<daVariablesList.length+1; i++) {
        if (daVariablesList[i]==='Traditional') {
            tempDaTraditional = tempDaTraditional +1;
        }
        if (daVariablesList[i]==='Initial') {
            tempDaInitial = tempDaInitial +1;
        }
        if (daVariablesList[i]==='Advanced') {
            tempDaAdvanced = tempDaAdvanced +1;
        }
        if (daVariablesList[i]==='Optimal') {
            tempDaOptimal = tempDaOptimal +1;
        } 
        if (daVariablesList[i]==='None') {
            tempDaNone = tempDaNone +1;
        } 
    } 

    let tempCcTraditional = 0;
    let tempCcInitial = 0;
    let tempCcAdvanced = 0;
    let tempCcOptimal = 0;
    let tempCcNone = 0;
    for (let i=0; i<ccVariablesList.length+1; i++) {
        if (ccVariablesList[i]==='Traditional') {
            tempCcTraditional = tempCcTraditional +1;
        }
        if (ccVariablesList[i]==='Initial') {
            tempCcInitial = tempCcInitial +1;
        }
        if (ccVariablesList[i]==='Advanced') {
            tempCcAdvanced = tempCcAdvanced +1;
        }
        if (ccVariablesList[i]==='Optimal') {
            tempCcOptimal = tempCcOptimal +1;
        } 
        if (ccVariablesList[i]==='None') {
            tempCcNone = tempCcNone +1;
        } 
    } 
  
    setIdScore(getVariableScores(id1) + getVariableScores(id2) + getVariableScores(id3) + getVariableScores(id4) + getVariableScores(id5) + getVariableScores(id6) + getVariableScores(id7));
    setDvScore(getVariableScores(dv1) + getVariableScores(dv2) + getVariableScores(dv3) + getVariableScores(dv4) + getVariableScores(dv5) + getVariableScores(dv6) + getVariableScores(dv7));
    setNtScore(getVariableScores(nt1) + getVariableScores(nt2) + getVariableScores(nt3) + getVariableScores(nt4) + getVariableScores(nt5) + getVariableScores(nt6) + getVariableScores(nt7));
    setAwScore(getVariableScores(aw1) + getVariableScores(aw2) + getVariableScores(aw3) + getVariableScores(aw4) + getVariableScores(aw5) + getVariableScores(aw6) + getVariableScores(aw7) + getVariableScores(aw8));
    setDaScore(getVariableScores(da1) + getVariableScores(da2) + getVariableScores(da3) + getVariableScores(da4) + getVariableScores(da5) + getVariableScores(da6) + getVariableScores(da7) + getVariableScores(da8));
    setCcScore(getVariableScores(cc1) + getVariableScores(cc2) + getVariableScores(cc3));
    

    setIdTraditional(tempIdTraditional);
    setIdInitial(tempIdInitial);
    setIdAdvanced(tempIdAdvanced);
    setIdOptimal(tempIdOptimal);
    setIdNone(tempIdNone);

    setDvTraditional(tempDvTraditional);
    setDvInitial(tempDvInitial);
    setDvAdvanced(tempDvAdvanced);
    setDvOptimal(tempDvOptimal);
    setDvNone(tempDvNone);

    setNtTraditional(tempNtTraditional);
    setNtInitial(tempNtInitial);
    setNtAdvanced(tempNtAdvanced);
    setNtOptimal(tempNtOptimal);
    setNtNone(tempNtNone);

    setAwTraditional(tempAwTraditional);
    setAwInitial(tempAwInitial);
    setAwAdvanced(tempAwAdvanced);
    setAwOptimal(tempAwOptimal);
    setAwNone(tempAwNone);

    setDaTraditional(tempDaTraditional);
    setDaInitial(tempDaInitial);
    setDaAdvanced(tempDaAdvanced);
    setDaOptimal(tempDaOptimal);
    setDaNone(tempDaNone);

    setCcTraditional(tempCcTraditional);
    setCcInitial(tempCcInitial);
    setCcAdvanced(tempCcAdvanced);
    setCcOptimal(tempCcOptimal);
    setCcNone(tempCcNone);


};



// DATA FOR PIE CHART
const data00 = [
  { name: 'Traditional', value: idTraditional + dvTraditional + ntTraditional + awTraditional + daTraditional + ccTraditional, fill: '#8884d8' },
  { name: 'Initial', value: idInitial + dvInitial + ntInitial + awInitial + daInitial + ccInitial, fill: '#459875' },
  { name: 'Advanced', value: idAdvanced + dvAdvanced + ntAdvanced + awAdvanced + daAdvanced + ccAdvanced, fill: '#987043' },
  { name: 'Optimal', value: idOptimal + dvOptimal + ntOptimal + awOptimal + daOptimal + ccOptimal, fill: '#342190' },
  { name: 'None', value: idNone + dvNone + ntNone + awNone + daNone + ccNone, fill: '#9c233dff' }
];


const AllUserAverage = ([
              {
                subject: 'Identity',
                A: 0.25,
                B: 7,
                C: 7,
                D: 0,
                E: 0,
                F: 0, 
                fullMark: 28,
                totalBarMax: 1
              },
              {
                subject: 'Devices',
                A: 0.5, 
                B: 14,
                C: 0,
                D: 7,
                E: 0,
                F: 0,  
                fullMark: 28,
                totalBarMax: 1
              },
              {
                subject: 'Networks',
                A: 0.25,
                B: 7,
                C: 7,
                D: 0,
                E: 0,
                F: 0, 
                fullMark: 28,
                totalBarMax: 1
              },
              {
                subject: 'Applications & Workloads',
                A: 0.5,
                B: 16, 
                C: 0,
                D: 8,
                E: 0,
                F: 0, 
                fullMark: 32,
                totalBarMax: 1
              },
              {
                subject: 'Data',
                A: 0.25,
                B: 8,
                C: 8,
                D: 0,
                E: 0,
                F: 0, 
                fullMark: 32,
                totalBarMax: 1
              },
              {
                subject: 'Cross-Cutting',
                A: 0.75,
                B: 9,
                C: 0,
                D: 0,
                E: 3,
                F: 0, 
                fullMark: 32,
                totalBarMax: 1
              },
          ])

const radarChartData1 = ([
              {
                subject: 'Identity',
                A: idScore/28,
                B: idScore,
                C: idTraditional,
                D: idInitial,
                E: idAdvanced,
                F: idOptimal, 
                fullMark: 28,
                totalBarMax: 1,
                allUserAverage: '0.25'
              },
              {
                subject: 'Devices',
                A: dvScore/28, 
                B: dvScore,
                C: dvTraditional,
                D: dvInitial,
                E: dvAdvanced,
                F: dvOptimal, 
                fullMark: 28,
                totalBarMax: 1,
                allUserAverage: '0.25'
              },
              {
                subject: 'Networks',
                A: ntScore/28,
                B: ntScore,
                C: ntTraditional,
                D: ntInitial,
                E: ntAdvanced,
                F: ntOptimal, 
                fullMark: 28,
                totalBarMax: 1,
                allUserAverage: '0.25'
              },
              {
                subject: 'Applications & Workloads',
                A: awScore/32,
                B: awScore, 
                C: awTraditional,
                D: awInitial,
                E: awAdvanced,
                F: awOptimal, 
                fullMark: 32,
                totalBarMax: 1,
                allUserAverage: '0.5'
              },
              {
                subject: 'Data',
                A: daScore/32,
                B: daScore,
                C: daTraditional,
                D: daInitial,
                E: daAdvanced,
                F: daOptimal, 
                fullMark: 32,
                totalBarMax: 1,
                allUserAverage: '0.5'
              },
              {
                subject: 'Cross-Cutting',
                A: ccScore/12,
                B: ccScore,
                C: ccTraditional,
                D: ccInitial,
                E: ccAdvanced,
                F: ccOptimal, 
                fullMark: 32,
                totalBarMax: 1,
                allUserAverage: '0.75'
              },
          ])

function createData(name, traditional, initial, advanced, optimal, score) {
  return { name, traditional, initial, advanced, optimal, score };
}

const rows = [
  createData('Identity', idTraditional, idInitial, idAdvanced, idOptimal, idScore),
  createData('Devices', dvTraditional, dvInitial, dvAdvanced, dvOptimal, dvScore),
  createData('Networks', ntTraditional, ntInitial, ntAdvanced, ntOptimal, ntScore),
  createData('Applications & Workflows', awTraditional, awInitial, awAdvanced, awOptimal, awScore),
  createData('Data', daTraditional, daInitial, daAdvanced, daOptimal, daScore),
  createData('Cross-Cutting', ccTraditional, ccInitial, ccAdvanced, ccOptimal, ccScore),
];

const gridStyle = { 
    m: '1em',
    alignContents:'stretch',
    border:`solid 3px ${theme.palette.primary.dark}`,
    borderRadius: '10px'
}

const columns = [
  {
      field: "questionID",
      headerName: "ID",
      flex: 0.25,
  },
  {
      field: "pillar",
      headerName: "Pillar",
      flex: 0.3,
  },
//   {
//       field: "description",
//       headerName: "Description",
//       flex: 1,
      
//   },
  {
      field: "function",
      headerName: "Function",
      flex: 0.5,
  },
  {
      field: "answer",
      headerName: "Answer",
      flex: 0.2,
  },
  {
      field: "answerDescription",
      headerName: "Answer Description",
      flex: 1,
  },
  {
      field: "comments",
      headerName: "Comments",
      flex: 0.75,
  },
];


// GET ZTA QUESTIONS FOR DATA GRID 
  const getZTAMMQuestions = async () => {
  try {
    const response = await axiosPrivate.get(`/zta`, {
        withCredentials: true
    });
    const data = await response.data;
    // console.log(data);
    setQuestions(data);

    let tempAnswersList = [];
   for (let i=0; i<data.length+1; i++) {
    // console.log(data[0].Pillar);
    tempAnswersList.push({
        _id: data[i]._id,
        pillar: data[i].Pillar,
        description: data[i].Description,
        function: data[i].Function,
        questionID: data[i].ID,
        answer: variablesList[i],
        answerDescription: data[i][variablesList[i]],
        comments: variablesCommentsList[i]
    })
    // console.log(tempAnswersList);
    setRowsDataGrid(tempAnswersList);
   }
   

  } catch (err) {
    // alert("Login Expired. access control");
    console.error(err);
    // navigate('/login', { state: { from: location }, replace: true });
  }
    
};


useEffect(() => {
  // getAssessmentData();
  getZTAAssessmentScores();
  getZTAMMQuestions();
}, []);  // eslint-disable-line react-hooks/exhaustive-deps


const dataBarChart = [
  {
    name: 'Identity',
    Traditional: (idTraditional/7),
    Initial: (idInitial/7),
    Advanced: (idAdvanced/7),
    Optimal: (idOptimal/7), 
    None: (idNone/7),
    TraditionalLabel: idTraditional,
    InitialLabel: idInitial,
    AdvancedLabel: idAdvanced,
    OptimalLabel: idOptimal, 
  },
  {
    name: 'Devices',
    Traditional: (dvTraditional/7),
    Initial: (dvInitial/7),
    Advanced: (dvAdvanced/7),
    Optimal: (dvOptimal/7),
    None: (dvNone/7),
    TraditionalLabel: idTraditional,
    InitialLabel: idInitial,
    AdvancedLabel: idAdvanced,
    OptimalLabel: idOptimal, 
  },
  {
    name: 'Networks',
   Traditional: (ntTraditional/7),
    Initial: (ntInitial/7),
    Advanced: (ntAdvanced/7),
    Optimal: (ntOptimal/7),
    None: (ntNone/7),
    TraditionalLabel: idTraditional,
    InitialLabel: idInitial,
    AdvancedLabel: idAdvanced,
    OptimalLabel: idOptimal, 
  },
  {
    name: 'Applications & Workflows',
    Traditional: (awTraditional/8),
    Initial: (awInitial/8),
    Advanced: (awAdvanced/8),
    Optimal: (awOptimal/8),
    None: (awNone/7),
    TraditionalLabel: idTraditional,
    InitialLabel: idInitial,
    AdvancedLabel: idAdvanced,
    OptimalLabel: idOptimal, 
  },
  {
    name: 'Data',
    Traditional: (daTraditional/8),
    Initial: (daInitial/8),
    Advanced: (daAdvanced/8),
    Optimal: (daOptimal/8),
    None: (daNone/7),
    TraditionalLabel: idTraditional,
    InitialLabel: idInitial,
    AdvancedLabel: idAdvanced,
    OptimalLabel: idOptimal, 
  },
  {
    name: 'Cross-Cutting',
    Traditional: (ccTraditional/3),
    Initial: (ccInitial/3),
    Advanced: (ccAdvanced/3),
    Optimal: (ccOptimal/3),
    None: (ccNone/7),
    TraditionalLabel: idTraditional,
    InitialLabel: idInitial,
    AdvancedLabel: idAdvanced,
    OptimalLabel: idOptimal, 
  }
];

const dataComposedBarChart = [
  {
    name: 'Your Answer',
    Total: 160,
    Results: idScore + dvScore + ntScore + awScore + daScore + ccScore,
    Average: 61,
    Low: 34,
    High: 123,
    Median: 72
  },
];



  return (
    <div>
        <Typography variant='h1'>Zero Trust Architecture Assessment Results: {assessmentName} </Typography>
        <Divider sx={{ mb:'1em' }} />
    <Grid container columns={12} sx={{ p:'1px', justifyContent:'space-evenly', alignContents:'stretch' }}>

         {/* TABLE OF ANSWERS BY ZTA PILLAR. */}
        <Grid item size={8} >
            <WidgetWrapper sx={ gridStyle } >
            <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>Zero Trust Pillars</TableCell>
                    <TableCell align="center">Traditional</TableCell>
                    <TableCell align="center">Initial</TableCell>
                    <TableCell align="center">Advanced</TableCell>
                    <TableCell align="center">Optimal</TableCell>
                    <TableCell align="center">Raw Score</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {rows.map((row) => (
                    <TableRow
                    key={row.name}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                    <TableCell component="th" scope="row">
                        {row.name}
                    </TableCell>
                    <TableCell align="center">{row.traditional}</TableCell>
                    <TableCell align="center">{row.initial}</TableCell>
                    <TableCell align="center">{row.advanced}</TableCell>
                    <TableCell align="center">{row.optimal}</TableCell>
                    <TableCell align="center">{row.score}</TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
            </TableContainer>
            </WidgetWrapper>
        </Grid>

         {/* RAW AND PERCENTAGE SCORES WIDGET*/}
        <Grid item size={4} >
            <WidgetWrapper sx={ gridStyle } >
                <Paper sx={{ p:'1em' }}>
            <Typography>Raw Score</Typography>
            <Typography sx={{ fontSize:'5em'}}>{idScore + dvScore + ntScore + awScore + daScore + ccScore}</Typography>  
            <Divider sx={{ mb:'1em' }} />
            <Typography>Percentage</Typography>
            <Typography sx={{ fontSize:'5em', }}>{(100*(idScore + dvScore + ntScore + awScore + daScore + ccScore) / 160).toFixed(2)}%</Typography>
                </Paper>
            </WidgetWrapper>
        </Grid>

          {/* RADAR CHART OF ANSWERS */}
        <Grid item size={6} >
          <WidgetWrapper sx={ gridStyle }>
            <Paper sx={{ p:'1em'}}>
            <RadarChartSimple data={radarChartData1}  />
            </Paper>
          </WidgetWrapper>
        </Grid>

        {/* PIE CHART OF ANSWERS */}
        <Grid item size={6} >
          <WidgetWrapper sx={ gridStyle }>
            <Paper sx={{ p:'1em'}}>
            <PieChartSimple data={data00} />
            </Paper>
          </WidgetWrapper>
        </Grid>
     

        {/* STACKED BAR CHART OF ANSWERS */}
        <Grid item size={6} >
          <WidgetWrapper sx={ gridStyle }>
            <Paper sx={{ p:'1em'}}>
            <StackedBarChart data={dataBarChart} />
            </Paper>
          </WidgetWrapper>
        </Grid>
       


      
        {/* COMPOSED CHART OF ANSWERS and AVERAGE */}
        <Grid item size={6} >
          <WidgetWrapper sx={ gridStyle }>
            
            <Paper sx={{ p:'1em' }}>
              <div style={{ width: '100%', height: 400 }}>
                <ResponsiveContainer width="100%" height="100%">
                <ComposedChart
                  data={dataComposedBarChart}
                  // margin={{
                  //   top: 20,
                  //   right: 0,
                  //   bottom: 0,
                  //   left: 0,
                  // }}
                  layout='vertical'
                >
                  <CartesianGrid stroke="#f5f5f5" />
                  <XAxis type='number' hide />
                  <YAxis dataKey="name" type='category' hide/>
                  <Tooltip shared={false} />
                  <Legend />
                  {/* <Area type="monotone" dataKey="amt" fill="#8884d8" stroke="#8884d8" /> */}
                  <Bar dataKey="Total" barSize={10} fill="#8884ebff" label={{
        position: "right",
        angle: 0,
        fill: " black",
        offset: -40
      }} />
                  {/* <Line type="monotone" dataKey="uv" stroke="#ff7300" /> */}
                  <Scatter dataKey="Results" fill="red" label={{ position: 'left', angle: -60, fill: "red", offset: -10}} />
                  <Scatter dataKey="Average" fill="orange" />
                  <Scatter dataKey="Low" fill="yellow" />
                  <Scatter dataKey="High" fill="green" />
                  <Scatter dataKey="Median" fill="#045153ff" />
                </ComposedChart>
                </ResponsiveContainer>
            </div>
            </Paper>
            
          </WidgetWrapper>
        </Grid>

      </Grid>
  


      {/* DATA GRID OF ANSWERS. */}
      <Grid item size={12} sx={ gridStyle }>
        <Box
                    // className={classes.root}
                    sx={{
                      mt:'0.5rem', flexGrow: 1, backgroundColor: theme.palette.background.alt, borderRadius: "0.75rem",
                      height: 1000,
                      width: '100%',
                      typography: '44pt',
                      "& .MuiDataGrid-columnHeaders": {
                          backgroundColor: theme.palette.neutral.light,
                          color: theme.palette.primary,
                          borderBottom: "solid 2px black",
                          borderTop: "solid 2px black",
                          fontSize: '1.5em'
                      },
                      "& .MuiDataGrid-virtualScroller": {
                          backgroundColor: theme.palette.primary.light,
                      },
                      "& .MuiDataGrid-footerContainer": {
                          backgroundColor: theme.palette.primary.main,
                          color: theme.palette.primary[100],
                          borderTop: "none"
                      },
                    //   "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    //       color: `${theme.palette.primary} !important`,
                    //   },
                      "& .MuiDataGrid-root .MuiDataGrid-cell": {
                            whiteSpace: "normal !important",
                            wordWrap: "break-word !important",
                            lineHeight: "1.5",
                            },
                        "& .even": {
                                // backgroundColor: theme.palette.neutral.rowEven,
                                backgroundColor: theme.palette.primary.rowEven,
                            },
                            "& .odd": {
                                // backgroundColor: theme.palette.neutral.rowOdd,
                                backgroundColor: theme.palette.primary.rowOdd,
                            },
                  }}
                  >
                    <DataGrid
                      rows={rowsDataGrid || []} 
                      getRowId={(row) => row._id}
                      getRowHeight={() => 'auto'}
                      columns={columns}
                      editMode="row"
                      loading={!rowsDataGrid}
                      columnHeaderHeight={112}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                      }
                      slots={{
                        toolbar: DataGridCustomToolbar,
                      }}
                    />
                  </Box>
      </Grid>



    {/* <LineChart
                        // style={{ width: '200px', height: '200px'}}
                        width={400}
                        height={400}
                        responsive
                        data={data}
                        margin={{
                          top: 5,
                          right: 0,
                          left: 0,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis width="auto" />
                        <Tooltip />
                        <Legend />
                        <Line type="monotone" dataKey="pv" stroke="#8884d8" activeDot={{ r: 8 }} />
                        <Line type="monotone" dataKey="uv" stroke="#82ca9d" />
                      </LineChart> */}
    </div>
  )
}

export default ZTAResults